import React from "react";
import ReactDOM from "react-dom";

// styles
import "../node_modules/purecss/build/pure-min.css";
import "../node_modules/purecss/build/grids-responsive-min.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/weather-icons/css/weather-icons.min.css";
import "react-tabs/style/react-tabs.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "react-image-lightbox/style.css";
import "./index.scss";
import "ol/ol.css";
import "react-mde/lib/styles/css/react-mde-toolbar.css";
import "react-mde/lib/styles/css/react-mde-editor.css";
import "react-mde/lib/styles/css/react-mde.css";
import "react-mde/lib/styles/css/react-mde-suggestions.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "react-toastify/dist/ReactToastify.css";
// components
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { preloadOfflineImages } from './db/db';
// fortawesome icons
import "./icons";

// Suppress benign "ResizeObserver loop completed" error by deferring callbacks
if (window.ResizeObserver) {
  const _ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
      super((...args) => requestAnimationFrame(() => callback(...args)));
    }
  };
}

// Rehydrate the in-memory offline image cache from IndexedDB. Deliberately not
// awaited — it reads every stored image, so blocking first paint on it would be
// slow for a large offline dataset.
preloadOfflineImages();

ReactDOM.render(<App />, document.getElementById("root"));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
